module.exports = __webpack_public_path__ + "img/slice.9f71167d.svg";